import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Drawer/drawer';
import { css } from '@patternfly/react-styles';
export var DrawerContext = React.createContext({
  isExpanded: false,
  isStatic: false
});
export var Drawer = function Drawer(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      _a$isExpanded = _a.isExpanded,
      isExpanded = _a$isExpanded === void 0 ? false : _a$isExpanded,
      _a$isInline = _a.isInline,
      isInline = _a$isInline === void 0 ? false : _a$isInline,
      _a$isStatic = _a.isStatic,
      isStatic = _a$isStatic === void 0 ? false : _a$isStatic,
      _a$position = _a.position,
      position = _a$position === void 0 ? 'right' : _a$position,
      props = __rest(_a, ["className", "children", "isExpanded", "isInline", "isStatic", "position"]);

  return React.createElement(DrawerContext.Provider, {
    value: {
      isExpanded: isExpanded,
      isStatic: isStatic
    }
  }, React.createElement("div", Object.assign({
    className: css(styles.drawer, isExpanded && styles.modifiers.expanded, isInline && styles.modifiers.inline, isStatic && styles.modifiers.static, position === 'left' && styles.modifiers.panelLeft, className)
  }, props), children));
};